<script setup lang="ts">
defineProps<{
    prefix?: string
    suffix?: string
    label?: string | number | boolean
    boldLabel?: boolean
    required?: boolean
}>()
</script>

<template>
    <slot />

    <span class="prefix-span" v-bind="$attrs">
        {{ prefix ? `${prefix}${required ? '*' : ''} :` : '' }}
        <slot name="edit">
            <span :class="boldLabel && 'bold'">
                {{ `${label}${suffix ?? ''}` }}
            </span>
        </slot>
    </span>
</template>

<style scoped lang="scss">
.typography-prefix-stack {
    & :deep(.text) {
        white-space: nowrap;
    }
}
.prefix-span {
    gap: 4px;
    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        & .field {
            width: 100%;
        }
    }
}
</style>
